module.exports = __webpack_public_path__ + "f992d7be530e2f1ce1c86d170496afe9.svg";